import { Form, Spin, Tabs } from 'antd';
import { useEffect, useState } from 'react';

import AffectedPayment from './AffectedPayment';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import PaymentHistory from './PaymentHistory';
import type React from 'react';
import UpcomingPayment from './UpcomingPayment';
import { useForm } from 'antd/lib/form/Form';

const PaymentTabs: React.FC = () => {
  const [form] = useForm();
  const tptype = 'CONC';
  const [color, setColor] = useState<string>();
  const [activeTabKey, setActiveTabKey] = useState<string>('1'); // Track active tab

  useEffect(() => {
    if (tptype === 'CONC') {
      setColor('green');
    } else if (tptype === 'PM') {
      setColor('duck-blue');
    } else if (tptype === 'SPM') {
      setColor('blue');
    }
  }, [tptype]);

  // Handle tab change
  const handleTabChange = (key: string) => {
    setActiveTabKey(key);
  };

  // Callback for when a tab is activated
  const handleTabActivated = (tabKey: string) => {
    console.log(`Tab ${tabKey} activated and data refreshed`);
  };

  return (
    <DF.Provider pagcode="paymentsfs">
      <Spin spinning={false}>
        <Form layout="vertical" form={form}>
          <Tabs
            className="tabs-border-top"
            activeKey={activeTabKey}
            onChange={handleTabChange}
          >
            <Tabs.TabPane
              forceRender
              tab={<GetLabel label="Upcoming" className="font-size-15" />}
              key="1"
            >
              <UpcomingPayment
                form={form}
                tpauthid={0}
                itemsCompanyHierarchyTree={[]}
                isActive={activeTabKey === '1'}
                onTabActivated={() => handleTabActivated('1')}
              />
            </Tabs.TabPane>
            <Tabs.TabPane
              forceRender
              tab={
                <GetLabel label="PaymentNotAffected" className="font-size-15" />
              }
              key="2"
            >
              <AffectedPayment />
            </Tabs.TabPane>
            <Tabs.TabPane
              forceRender
              tab={<GetLabel label="PaymentHistory" className="font-size-15" />}
              key="3"
            >
              <PaymentHistory
                form={form}
                tpauthid={0}
                itemsCompanyHierarchyTree={[]}
                isActive={activeTabKey === '3'}
                onTabActivated={() => handleTabActivated('3')}
              />
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

export default PaymentTabs;
